import { render, staticRenderFns } from "./w-site-navbar.vue?vue&type=template&id=19797fd0"
import script from "./w-site-navbar.vue?vue&type=script&lang=js"
export * from "./w-site-navbar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../website-admin/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports